import styled from 'styled-components';

import { Column, HeaderMixin } from '../../shared/styles';

const NameColumn = styled(Column)`
  width: 30%;
`;

const PartnershipColumn = styled(Column)`
  width: 15%;
`;

const MemberCountColumn = styled(Column)`
  width: 15%;
`;

const ActionColumn = styled(Column)`
  width: 40%;
`;

const BrandTitle = styled.h5`
  ${HeaderMixin};
  font-size: 14px;
  text-align: left;
  margin: 0 0 8px 0;
`;

const Dot = styled.span`
  display: inline-block;
  height: 6px;
  width: 6px;
  background-color: #c19d3f;
  border-radius: 50%;
  margin-bottom: 6px;
`;

export {
  ActionColumn,
  BrandTitle,
  Dot,
  NameColumn,
  PartnershipColumn,
  MemberCountColumn,
};
